import { getUvid } from '@/utils/uvid'
import { uploadIdMap } from '@/api/idmap'

export default function handleIdMap(param) {
  // param来自客户端，需要客户端使用URLEncoder.encode("url", "utf-8")方法对参数编码
  if (param) {
    let gaid = decodeURIComponent(param)
    let uvid = getUvid()
    if (gaid && uvid) {
      uploadIdMap({
        gaid: gaid,
        uvid: uvid,
      })
        .then(() => {})
        .catch(() => {})
    }
  }
}
